var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinnerCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.424 57.0015C106.577 56.6192 108.651 58.0554 108.839 60.2344C109.566 68.7033 107.826 77.2334 103.786 84.776C99.1203 93.4864 91.6584 100.373 82.6024 104.326C73.5463 108.279 63.4232 109.068 53.8637 106.567C44.3042 104.066 35.8648 98.4206 29.9048 90.5392C23.9448 82.6577 20.8112 72.9995 21.0088 63.1203C21.2064 53.241 24.7236 43.7158 30.9939 36.0789C37.2642 28.4421 45.9226 23.1381 55.5745 21.0214C63.9324 19.1885 72.6139 19.8379 80.5644 22.8448C82.61 23.6184 83.4268 26.0056 82.4725 27.9734C81.5181 29.9413 79.1542 30.7402 77.0937 30.0072C70.7581 27.7531 63.8908 27.3058 57.2711 28.7576C49.3566 30.4933 42.2567 34.8425 37.115 41.1047C31.9733 47.367 29.0892 55.1776 28.9272 63.2786C28.7652 71.3796 31.3347 79.2993 36.2219 85.7621C41.1091 92.2249 48.0295 96.8545 55.8683 98.9053C63.707 100.956 72.008 100.308 79.4339 97.067C86.8599 93.8255 92.9786 88.1788 96.8045 81.0364C100.005 75.0624 101.445 68.3329 101.002 61.623C100.858 59.4407 102.27 57.3838 104.424 57.0015Z",
    fill: "#8D00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 32L65 72L53 60.012",
    stroke: "#8D00FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerCheckIcon);
export default __webpack_public_path__ + "static/media/spinner-check-icon.f43245f931c7c9e53ab980239e268e82.svg";
export { ForwardRef as ReactComponent };